import { FlexBetween, FlexCol } from "./ui";
import NoSelectableBox from "./ui/noSelectableBox";
import { IServiceCard } from "@/interfaces";
import { cva } from "class-variance-authority";
import { cn } from "@/lib";

const textStyles = cva("", {
  variants: {
    variant: {
      "emerald-mint": "text-emerald-mint!",
      "sky-bliss": "text-sky-bliss!",
      "teal-ocean": "text-teal-ocean!",
      "sunset-gold": "text-sunset-gold!",
      "yellow-500": "text-yellow-500",
      "rose-500": "text-rose-500!",
    },
  },
});

const sectionStyles = cva("size-full border-r-2 pb-24 lg:px-8 px-4 relative", {
  variants: {
    variant: {
      "emerald-mint": "border-emerald-mint",
      "sky-bliss": "border-sky-bliss",
      "teal-ocean": "border-teal-ocean",
      "sunset-gold": "border-sunset-gold",
      "yellow-500": "border-yellow-500",
      "rose-500": "border-rose-500",
    },
  },
});

const circleStyles = cva("absolute size-3.5 rounded-full  z-10 -right-[8px]", {
  variants: {
    variant: {
      "emerald-mint": "bg-emerald-mint",
      "sky-bliss": "bg-sky-bliss",
      "teal-ocean": "bg-teal-ocean",
      "sunset-gold": "bg-sunset-gold",
      "yellow-500": "bg-yellow-500",
      "rose-500": "bg-rose-500",
    },
  },
});

const ContinuousServicesSegment = (
  props: IServiceCard & { anchorId?: string },
) => {
  const [firstLabelPart, secondLabelPart] = props.category.split(" ");

  return (
    <section
      id={props.anchorId ?? `service-${props.id}`}
      className={cn(sectionStyles({ variant: props.variant }), props.category)}
    >
      <div className={circleStyles({ variant: props.variant })}></div>
      <FlexCol gap={8}>
        <FlexBetween gap={1} className="w-max text-sm font-bold lg:text-lg">
          <span>{firstLabelPart}</span>
          <span className={textStyles({ variant: props.variant })}>
            {secondLabelPart}
          </span>
        </FlexBetween>
        <div className="grid grid-cols-12 gap-6 pr-3 sm:gap-x-0 sm:pr-8 lg:gap-12">
          {props.services.map((item, i) => (
            <div key={i} className="col-span-4 md:col-span-3">
              <NoSelectableBox
                icon={item.icon}
                label={item.label}
                href={item.href}
                variant={props.variant}
                key={String(item.id)}
                id={item.id}
                disabled={item.disabled === "unavailability"}
              />
            </div>
          ))}
        </div>
      </FlexCol>
    </section>
  );
};

export default ContinuousServicesSegment;
